import React, {useEffect, useState} from 'react';
import {Grid, Typography, useTheme} from "@mui/material";
import SignatureCanvas from 'react-signature-canvas';
import {useTranslation} from "react-i18next";
import {IStep} from "../DigitalSign";
import {Box} from "@mui/system";
import ConsentStep from "./ConsentStep";

export interface ISignStep {
    step: IStep;
    signRef: SignatureCanvas | null;
    setSignRef: (ref: SignatureCanvas | null) => void;
    setSignIsPresent: (value: boolean) => void;
    setStep?: (step: IStep) => void;
    hideTitle?: boolean;
}

const SignStep = (props: ISignStep) => {
    const {t} = useTranslation(['network']);
    const theme = useTheme();
    const [width] = useState(window.innerWidth * 80 / 100);

    return (
        <Grid container
              justifyContent="center"
              alignItems="center" >
            {!props.hideTitle && <Typography variant="h6">{t(`digitalSign.step.${props.step["step-key"]}.title`)}</Typography>}
            {props.step["step-url"] === "/consent" && (
                <Grid item>
                    <ConsentStep step={props.step} setStep={props.setStep}/>
                </Grid>
            )}
            <Box sx={{width: width, marginTop:'16px'}}>
                <Typography variant="body2">{t(`digitalSign.step.${props.step["step-key"]}.description`)}</Typography>
            </Box>
            <Box sx={{width: width, border: '1px solid', borderColor: theme.palette.accent.main, marginTop: 2, backgroundColor: theme.palette.neutral.main}}>
                <SignatureCanvas
                    ref={(ref) => {
                        props.setSignRef(ref);
                    }}
                    onEnd={() => {
                        props.setSignIsPresent(!props.signRef?.isEmpty())
                    }}
                    penColor={theme.palette.primary.main}
                    canvasProps={{width: width, height: width / 5}}
                    clearOnResize={false}
                />
            </Box>
        </Grid>
    );
};

export default SignStep;
